module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av754-21ca2bb28b44c56f3edf603f16a5a786.jpg";